/** Shared Moon product palette for package-level product surfaces. */
export const EMBER = {
  colors: {
    warm: "#8B3A1A",
    warmDark: "#1A0A02",
    warmLight: "#FDDAB0",
    coral: "#A8563A",
    teal: "#5E6E3E",
    blue: "#6B5A4E",
    green: "#4E7342",
    gold: "#B08030",
    cryo: "#7A8B8E",
    embryo: "#C97B5E",
    text: "#2A2522",
    textMid: "#5A4D45",
    textLight: "#8A7D74",
    textFaint: "#B0A49A",
    bg: "#FAF6F2",
    bgEnd: "#F5F0EB",
    border: "#E8E0D8",
    surface: "#FFFFFF",
  },
} as const;
